import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useLazyQualificationByEmailQuery } from '../../../../store/features/qualification/qualificationSlice';
import { GuestUserFindQualificationInputs } from '../types';
import { QualificationFindForm } from './QualificationFindForm';
import { guestUserFindQualificationValidationSchema } from './validation';

interface QualificationFindFormContainerProps {
  onGuestUserWithoutQualificationFound: () => void;
  onFoundGuestUser?: () => void;
}
export const QualificationFindFormContainer: React.FC<QualificationFindFormContainerProps> = ({
  onGuestUserWithoutQualificationFound,
  onFoundGuestUser,
}) => {
  const [findQualificationByEmail, { isFetching, data, isSuccess, isError, error }] =
    useLazyQualificationByEmailQuery();
  const form = useForm<GuestUserFindQualificationInputs>({
    resolver: yupResolver(guestUserFindQualificationValidationSchema),
    mode: 'onTouched',
  });

  const onSubmit = async (data: GuestUserFindQualificationInputs) => {
    await findQualificationByEmail(data.email);
  };

  // Redirect to edit form for qualification in case no qualification has been added for guest user
  useEffect(() => {
    if (isSuccess && data) {
      if (!data.qualification) {
        onGuestUserWithoutQualificationFound();
      } else {
        onFoundGuestUser && onFoundGuestUser();
      }
    }
  }, [data, isSuccess, onGuestUserWithoutQualificationFound, onFoundGuestUser]);

  return (
    <QualificationFindForm
      form={form}
      onSubmit={onSubmit}
      isFetching={isFetching}
      isError={isError}
      errorMessage={error?.message}
    />
  );
};
